var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoblack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.262,
    height: 44.27,
    viewBox: "0 0 240.262 44.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-44.633 -208.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M94.288,247.079q2.244,2.213,0,4.457t-4.457,0L71.94,233.677H57.462v15.805q0,3.161-3.161,3.161t-3.161-3.161v-37.9q0-3.16,3.161-3.161t3.161,3.161v15.805H71.94l17.891-17.86q2.213-2.244,4.457,0t0,4.457L77.819,230.516Z",
    transform: "translate(-6.507 -0.05)",
    fill: "#20404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M197.624,211.516q0-3.161,3.161-3.161t3.161,3.161v37.932q0,3.161-3.161,3.161t-3.161-3.161Z",
    transform: "translate(-98.781 0)",
    fill: "#20404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M265.612,209.525q2.212-2.244,4.457,0t0,4.457L232.959,251a4.146,4.146,0,0,1-2.971,1.612,2.744,2.744,0,0,1-3.066-3.066V211.516q0-3.161,3.161-3.161t3.161,3.161V241.83Z",
    transform: "translate(-111.397 0)",
    fill: "#20404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M402.7,249.448V211.516q0-3.161,3.161-3.161t3.161,3.161v34.771H443.8q3.16,0,3.161,3.161t-3.161,3.161H405.864Q402.7,252.609,402.7,249.448Z",
    transform: "translate(-232.969 0)",
    fill: "#20404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M549.187,211.516q0-3.161,3.161-3.161t3.161,3.161v37.932q0,3.161-3.161,3.161t-3.161-3.161Z",
    transform: "translate(-325.242 0)",
    fill: "#20404a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M621.632,247.079q2.244,2.213,0,4.457t-4.457,0l-17.891-17.86H584.806v15.805q0,3.161-3.161,3.161t-3.161-3.161v-37.9q0-3.16,3.161-3.161t3.161,3.161v15.805h14.478l17.891-17.86q2.212-2.244,4.457,0t0,4.457l-16.469,16.532Z",
    transform: "translate(-337.859 -0.033)",
    fill: "#20404a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblack);
export default __webpack_public_path__ + "static/media/logoblack.d55debb037b3a4c903251362657f832d.svg";
export { ForwardRef as ReactComponent };